import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';
import { LanguageService } from '../../../core/services/language.service';
import { RoutesPath } from '../../constants/routes-path';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  standalone: true,
  selector: 'app-breadcrumb',
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  lang: any = 'en';
  // This method is used to initialize the class instance using router, route, and language service
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private languageService: LanguageService
  ) {
    this.lang = this.languageService.getCurrentLang();
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    // build once on initial load
    this.breadcrumbs = this.prependDashboardIfNeeded(
      this.buildBreadcrumb(this.route.root)
    );

    // rebuild on route change
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.prependDashboardIfNeeded(
          this.buildBreadcrumb(this.route.root)
        );
      });
  }

  // This method is used to build breadcrumb using route, url, and breadcrumbs
  private buildBreadcrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) return breadcrumbs;

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL) {
        url += `/${routeURL}`;
      }

      const label = child.snapshot.data['breadcrumb'];
      if (label) {
        breadcrumbs.push({ label, url });
      }

      return this.buildBreadcrumb(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  private prependDashboardIfNeeded(breadcrumbs: Breadcrumb[]): Breadcrumb[] {
    if (!breadcrumbs || breadcrumbs.length !== 1) return breadcrumbs;
    const dashboard: Breadcrumb = {
      label: 'DASHBOARD',
      url: `/${RoutesPath.DASHBOARD}`,
    };
    return [dashboard, ...breadcrumbs];
  }
}
